(function () {
  var sectionEl = document.querySelector('[data-hvac-tp-id]');
  if (!sectionEl) return;
  var id = sectionEl.getAttribute('data-hvac-tp-id');

  var SC = {
    'Alabama':['Birmingham','Montgomery','Huntsville','Mobile','Tuscaloosa','Dothan','Auburn','Hoover'],
    'Alaska':['Anchorage','Fairbanks','Juneau','Sitka','Ketchikan','Wasilla','Kenai','Kodiak'],
    'Arizona':['Phoenix','Tucson','Mesa','Chandler','Scottsdale','Glendale','Tempe','Peoria'],
    'Arkansas':['Little Rock','Fort Smith','Fayetteville','Springdale','Jonesboro','North Little Rock','Conway','Rogers'],
    'California':['Los Angeles','San Diego','San Jose','San Francisco','Fresno','Sacramento','Long Beach','Oakland'],
    'Colorado':['Denver','Colorado Springs','Aurora','Fort Collins','Lakewood','Thornton','Arvada','Westminster'],
    'Connecticut':['Bridgeport','New Haven','Hartford','Stamford','Waterbury','Norwalk','Danbury','New Britain'],
    'Delaware':['Wilmington','Dover','Newark','Middletown','Smyrna','Milford','Seaford','Georgetown'],
    'Florida':['Jacksonville','Miami','Tampa','Orlando','St. Petersburg','Hialeah','Tallahassee','Port St. Lucie'],
    'Georgia':['Atlanta','Columbus','Augusta','Savannah','Athens','Sandy Springs','Roswell','Macon'],
    'Hawaii':['Honolulu','Pearl City','Hilo','Kailua','Waipahu','Kaneohe','Mililani','Kahului'],
    'Idaho':['Boise','Meridian','Nampa','Idaho Falls','Pocatello','Caldwell',"Coeur d'Alene",'Twin Falls'],
    'Illinois':['Chicago','Aurora','Joliet','Naperville','Rockford','Springfield','Peoria','Elgin'],
    'Indiana':['Indianapolis','Fort Wayne','Evansville','South Bend','Carmel','Fishers','Bloomington','Hammond'],
    'Iowa':['Des Moines','Cedar Rapids','Davenport','Sioux City','Iowa City','Waterloo','Ames','West Des Moines'],
    'Kansas':['Wichita','Overland Park','Kansas City','Topeka','Olathe','Lawrence','Shawnee','Manhattan'],
    'Kentucky':['Louisville','Lexington','Bowling Green','Owensboro','Covington','Richmond','Georgetown','Florence'],
    'Louisiana':['New Orleans','Baton Rouge','Shreveport','Lafayette','Lake Charles','Kenner','Bossier City','Monroe'],
    'Maine':['Portland','Lewiston','Bangor','South Portland','Auburn','Biddeford','Sanford','Saco'],
    'Maryland':['Baltimore','Columbia','Germantown','Silver Spring','Waldorf','Glen Burnie','Ellicott City','Frederick'],
    'Massachusetts':['Boston','Worcester','Springfield','Cambridge','Lowell','Brockton','New Bedford','Lynn'],
    'Michigan':['Detroit','Grand Rapids','Warren','Sterling Heights','Lansing','Ann Arbor','Flint','Dearborn'],
    'Minnesota':['Minneapolis','Saint Paul','Rochester','Duluth','Bloomington','Brooklyn Park','Plymouth','Maple Grove'],
    'Mississippi':['Jackson','Gulfport','Southaven','Hattiesburg','Biloxi','Meridian','Tupelo','Olive Branch'],
    'Missouri':['Kansas City','Saint Louis','Springfield','Columbia','Independence',"Lee's Summit","O'Fallon",'St. Joseph'],
    'Montana':['Billings','Missoula','Great Falls','Bozeman','Butte','Helena','Kalispell','Havre'],
    'Nebraska':['Omaha','Lincoln','Bellevue','Grand Island','Kearney','Fremont','Hastings','Norfolk'],
    'Nevada':['Las Vegas','Henderson','Reno','North Las Vegas','Sparks','Carson City','Fernley','Elko'],
    'New Hampshire':['Manchester','Nashua','Concord','Derry','Rochester','Salem','Dover','Merrimack'],
    'New Jersey':['Newark','Jersey City','Paterson','Elizabeth','Edison','Woodbridge','Lakewood','Toms River'],
    'New Mexico':['Albuquerque','Las Cruces','Rio Rancho','Santa Fe','Roswell','Farmington','Clovis','Hobbs'],
    'New York':['New York City','Buffalo','Rochester','Yonkers','Syracuse','Albany','New Rochelle','Cheektowaga'],
    'North Carolina':['Charlotte','Raleigh','Greensboro','Durham','Winston-Salem','Fayetteville','Cary','Wilmington'],
    'North Dakota':['Fargo','Bismarck','Grand Forks','Minot','West Fargo','Williston','Dickinson','Mandan'],
    'Ohio':['Columbus','Cleveland','Cincinnati','Toledo','Akron','Dayton','Parma','Canton'],
    'Oklahoma':['Oklahoma City','Tulsa','Norman','Broken Arrow','Lawton','Edmond','Moore','Midwest City'],
    'Oregon':['Portland','Salem','Eugene','Gresham','Hillsboro','Beaverton','Bend','Medford'],
    'Pennsylvania':['Philadelphia','Pittsburgh','Allentown','Erie','Reading','Scranton','Bethlehem','Lancaster'],
    'Rhode Island':['Providence','Cranston','Warwick','Pawtucket','East Providence','Woonsocket','Coventry','Cumberland'],
    'South Carolina':['Columbia','Charleston','North Charleston','Mount Pleasant','Rock Hill','Greenville','Summerville','Goose Creek'],
    'South Dakota':['Sioux Falls','Rapid City','Aberdeen','Brookings','Watertown','Mitchell','Yankton','Pierre'],
    'Tennessee':['Nashville','Memphis','Knoxville','Chattanooga','Clarksville','Murfreesboro','Franklin','Jackson'],
    'Texas':['Houston','San Antonio','Dallas','Austin','Fort Worth','El Paso','Arlington','Corpus Christi'],
    'Utah':['Salt Lake City','West Valley City','Provo','West Jordan','Orem','Sandy','Ogden','St. George'],
    'Vermont':['Burlington','Essex','South Burlington','Colchester','Rutland','Bennington','Brattleboro','Hartford'],
    'Virginia':['Virginia Beach','Norfolk','Chesapeake','Richmond','Newport News','Alexandria','Hampton','Roanoke'],
    'Washington':['Seattle','Spokane','Tacoma','Vancouver','Bellevue','Kent','Everett','Renton'],
    'West Virginia':['Charleston','Huntington','Morgantown','Parkersburg','Wheeling','Weirton','Fairmont','Martinsburg'],
    'Wisconsin':['Milwaukee','Madison','Green Bay','Kenosha','Racine','Appleton','Waukesha','Oshkosh'],
    'Wyoming':['Cheyenne','Casper','Laramie','Gillette','Rock Springs','Sheridan','Green River','Evanston']
  };

  var TITLES = [
    'Best Mini Split I Have Owned',
    'Great Heat Pump, Great Price',
    'Top Notch Air Conditioning',
    'Reliable and Efficient System',
    'Fast Shipping, Easy Setup',
    'Handles Extreme Weather Easily',
    'Perfect Year-Round Comfort',
    'Best Investment for Our Home',
    'Incredible Value and Service'
  ];

  var BODIES = [
    'Installation was a breeze and the unit runs whisper quiet. My energy bill dropped significantly in the first month. HVAC MORE had everything I needed and shipped faster than expected.',
    'I was skeptical buying HVAC equipment online but this exceeded all my expectations. The heat pump keeps our home perfectly comfortable year-round and setup was surprisingly simple.',
    'Outstanding quality at an unbeatable price. The mini split handles extreme temperatures without breaking a sweat. Customer support walked me through every step of the installation.',
    'After years of struggling with old window units, this system is a game changer. Energy savings have been incredible and the air quality in our home improved noticeably from day one.',
    'Fast shipping and everything arrived well packaged. The instructions were clear and the unit has been running flawlessly for months now. Highly recommend HVAC MORE to anyone.',
    'Knocked nearly 35% off our monthly utility bill. The quiet operation is a huge bonus - you honestly forget it is even running. Best investment we have made for our home.',
    'Great value for a top-quality system. The installation kit included everything we needed and the online resources made setup easy even without prior HVAC experience. Five stars.',
    'We replaced an aging central unit and could not be happier. The difference in efficiency is night and day. HVAC MORE had the best price we found after shopping around for weeks.',
    'Impressed by how well it handles both heating and cooling. No more seasonal swaps - one system does it all. The factory-direct pricing saved us over $800 versus local dealers.'
  ];

  var ABBR = {AL:'Alabama',AK:'Alaska',AZ:'Arizona',AR:'Arkansas',CA:'California',CO:'Colorado',CT:'Connecticut',DE:'Delaware',FL:'Florida',GA:'Georgia',HI:'Hawaii',ID:'Idaho',IL:'Illinois',IN:'Indiana',IA:'Iowa',KS:'Kansas',KY:'Kentucky',LA:'Louisiana',ME:'Maine',MD:'Maryland',MA:'Massachusetts',MI:'Michigan',MN:'Minnesota',MS:'Mississippi',MO:'Missouri',MT:'Montana',NE:'Nebraska',NV:'Nevada',NH:'New Hampshire',NJ:'New Jersey',NM:'New Mexico',NY:'New York',NC:'North Carolina',ND:'North Dakota',OH:'Ohio',OK:'Oklahoma',OR:'Oregon',PA:'Pennsylvania',RI:'Rhode Island',SC:'South Carolina',SD:'South Dakota',TN:'Tennessee',TX:'Texas',UT:'Utah',VT:'Vermont',VA:'Virginia',WA:'Washington',WV:'West Virginia',WI:'Wisconsin',WY:'Wyoming'};

  function normalizeRegion(r) {
    if (!r) return r;
    return r.length === 2 ? (ABBR[r.toUpperCase()] || r) : r;
  }

  var applied = false;

  function applyGeo(region, city) {
    if (applied) return;
    var cities = SC[region];
    if (!cities) return;
    var grid = document.getElementById('hvac-tp-grid-' + id);
    if (!grid) return;
    applied = true;

    var headEl = document.getElementById('hvac-tp-heading-' + id);
    if (headEl) {
      headEl.textContent = '';
      headEl.appendChild(document.createTextNode(region + '’s trusted HVAC supplier'));
      headEl.appendChild(document.createElement('br'));
      headEl.appendChild(document.createTextNode('for homeowners & contractors'));
    }

    var cards = grid.querySelectorAll('.hvac-tp__card[data-rating]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var c = (i === 0 && city && city.trim()) ? city.trim() : cities[i % cities.length];
      var locEl   = card.querySelector('.hvac-tp__location');
      var titleEl = card.querySelector('.hvac-tp__quote-title');
      var bodyEl  = card.querySelector('.hvac-tp__body');
      if (locEl)   locEl.textContent   = c + ', ' + region;
      if (titleEl) titleEl.textContent = '‘' + region + ' – ' + TITLES[i % TITLES.length] + '’';
      if (bodyEl)  bodyEl.textContent  = BODIES[i % BODIES.length];
    }
  }

  function tryCache() {
    try {
      var c = JSON.parse(sessionStorage.getItem('hvac_geo_v1') || 'null');
      if (c && c.region) {
        applyGeo(normalizeRegion(c.region), c.city || '');
        return applied;
      }
    } catch (e) {}
    return false;
  }

  function detectState() {
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      var TZ = {
        'America/New_York':'New York','America/Chicago':'Illinois',
        'America/Denver':'Colorado','America/Los_Angeles':'California',
        'America/Phoenix':'Arizona','America/Boise':'Idaho',
        'America/Anchorage':'Alaska','Pacific/Honolulu':'Hawaii',
        'America/Detroit':'Michigan','America/Indianapolis':'Indiana'
      };
      return TZ[tz] || null;
    } catch(e) { return null; }
  }

  function init() {
    if (tryCache()) return;
    var state = detectState();
    if (!state) return;
    var geo = { region: state, city: '', postal: '', ts: Date.now() };
    try { sessionStorage.setItem('hvac_geo_v1', JSON.stringify(geo)); } catch(e) {}
    applyGeo(state, '');
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(init, { timeout: 800 });
  } else {
    setTimeout(init, 0);
  }
})();
